import { FlagType } from 'src/app/slice';
import { SideNavLink } from '@amzn/aac-chrome-internal-api';
import React from 'react';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { toSentenceCase } from 'src/commons/utils/helpers';

interface RenderFlagOptions {
  isMobile?: boolean;
  isInverted?: boolean;
}

export const formatFlagType = (tag?: string): FlagType => {
  return (tag?.toLowerCase() as FlagType) || 'beta';
};

// Tag labels should use sentence case
// https://storm.advertising.amazon.dev/components/tag/
export const formatFlagLabel = (flagLabel: string): string => {
  const normalizedLabel = flagLabel.trim().replace(/\s+/g, ' ');
  return toSentenceCase(normalizedLabel);
};

// To be refactored to accept a Flag instead of the navItem after isNew and isBeta fields are deprecated
export const renderFlag = (
  navItem: SideNavLink,
  options?: RenderFlagOptions,
): React.ReactElement | null => {
  if (!navItem.calloutTag) {
    return null;
  }

  return (
    <LaunchFlag
      flag={{
        type: navItem.calloutTag,
        label: navItem.calloutTag,
        ...options,
      }}
    />
  );
};
